export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";